import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "warning",
  "use": "warning-usage",
  "viewBox": "0 0 19 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 19\" id=\"warning\"><path fill-rule=\"evenodd\" d=\"m10.34 13 .25-7.67H9.1L9.34 13zM7.92 2.06C8.95.1 10.63.1 11.67 2.05l6.74 12.73c1.04 1.96.1 3.54-2.12 3.54h-13c-2.2 0-3.15-1.59-2.12-3.54L7.92 2.05zm1.92 14.11a.9.9 0 0 0 .88-.88c0-.48-.4-.88-.88-.88s-.88.4-.88.88c0 .46.4.88.88.88\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol